import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, Subject } from "rxjs";

@Injectable()
export class SecurityProfileService {
  apiURL = environment.API + "/attempts";
  apiURLPublic = environment.APIpublic;

  userAdmin = false;

  private keyToWatch = "attempt";
  private previousValue: any;

  private valueChangedSubject = new Subject<any>();
  valueChanged$ = this.valueChangedSubject.asObservable();

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };
  constructor(private httpClient: HttpClient) {}

  setSecurityProfileById(
    userName: string,
    appUrlToRedirect: "SURFACE" | "RM" | "WORKSPACE"
  ): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL +
        `/set-login-attempts?userName=${userName}&r=${appUrlToRedirect}`,
      this.httpOptions
    );
  }

  resetAttempts(userName: string): Observable<any> {
    return this.httpClient.post<any>(
      this.apiURL + `/reset-attempts/${userName}`,
      this.httpOptions
    );
  }

  private startWatching() {
    setInterval(() => {
      const currentValue = sessionStorage.getItem(this.keyToWatch);
      if (currentValue !== this.previousValue) {
        this.valueChangedSubject.next(currentValue);
        this.previousValue = currentValue;
      }
    }, 2000); // Verifica a cada segundo (você pode ajustar o intervalo conforme necessário)
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/securityProfile/securityProfile.service.ts